import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog, FlatButton, Paper, Checkbox } from 'material-ui';
import EditLog from './edit-log';
import injectSheet from 'react-jss';
import moment from 'moment';
import { push as routerPush } from 'react-router-redux';
import SideBySideComparison from './side-by-side-comparison-modal';
import R from 'ramda';

const styles = {
  foldAll: {
    margin: '16px 16px 0',
  },
  logContainer: {
    display: 'inline-block',
    borderRadius: '10px !important',
    margin: '0 2em 2em 2em',
    padding: '16px',
    width: 'calc(100% - 4em)',
  },
  logHeader: {
  },
  logBody: {
    borderTop: '1px solid #e0e0e0',
    paddingTop: '12px',
    marginTop: '12px',
    whiteSpace: 'pre-wrap',
  },
  dateSplit: {
    color: '#3e5a6d',
    fontSize: '14px',
    padding: '1em 0 1em 1em',
    display: 'flex',
    alignItems: 'center',
  },
  rateSheetsBox: {
    border: '2px solid #e0e0e0',
    borderRadius: '4px',
  },
  rateSheetsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    padding: '8px',
  },
};

class c extends Component {
  constructor() {
    super();
    this.state = {
      openSideBySide: false,
      logIndexToOpen: -1,
      allFolded: false,
    };
  }
  onCheckFoldAll = () => this.setState({ allFolded: !this.state.allFolded });
  openDialog = index => () => this.setState({ openSideBySide: true, logIndexToOpen: index });
  closeDialog = () => this.setState({ openSideBySide: false, logIndexToOpen: -1 });
  render() {
    const { logs = [], classes: css, push } = this.props;
    const {
      allFolded,
    } = this.state;
    return (
      <div style={{ marginTop: '32px', padding: '0 6em' }}>
        <Checkbox
          label={allFolded ? 'Expand All' : 'Collapse All'}
          checked={allFolded}
          onCheck={this.onCheckFoldAll}
          className={css.foldAll}
        />
        {
          logs.map((log, i) => {
            const prev = logs[i - 1];
            const dayActorLabel = !prev
              || !moment(prev.createdAt).isSame(log.createdAt, 'day')
              || prev.actor !== log.actor
              || prev.action !== log.action
              ? (
                  <div className={css.dateSplit}>
                    <div>{moment(log.createdAt).format('DD MMMM YYYY')}</div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <b>{log.actor}</b>
                    &nbsp;
                    <b>{log.action}</b>&nbsp;this template {log.version ? `(version ${log.version})` : ''}
                  </div>
                )
                : null;
            return (
              <div key={i}>
                {dayActorLabel}
                <Paper
                  style={allFolded || (log.action !== 'edited' && !log.message) ? { display: 'none' } : {}}
                  className={css.logContainer}
                >
                  <div className={css.logHeader}>
                    <small>{moment(log.createdAt).format('D MMM YYYY, H:mm')}</small>
                  </div>

                  {
                    (() => {
                      if (log.action === 'edited') {
                        return (
                          <div
                            className={css.logBody}
                          >
                            <EditLog
                              {...log}
                            />
                            <a onClick={this.openDialog(i)} style={{ cursor: 'pointer' }}>
                              Open side by side comparison
                            </a>
                          </div>
                        );
                      }
                      if (log.message) {
                        return (
                          <div
                            className={css.logBody}
                          >
                            <div>
                              <b>Subject: </b>{
                              log.message.bodyJson.subject
                            }
                            </div>
                            <b>Message: </b>{
                            log.message.bodyJson.message
                          }
                          {
                            Boolean(log.message.bodyJson.rateDocIds && log.message.bodyJson.rateDocIds.length) && (
                              <div className={css.rateSheetsBox}>
                                <div className={css.rateSheetsHeader}>
                                  <div style={{ fontSize: '16px' }}>Rate Sheets</div>
                                  <FlatButton
                                    label="View Rates"
                                    style={{ border: '1px solid #e0e0e0' }}
                                    onClick={() => push(`/contracting/contract/${log.message.contractId}/policies`)}
                                  />
                                </div>
                                {
                                  R.values(log.message.bodyJson.rateDocsMap || {}).map(obj => (
                                    <div key={obj.threadId} style={{ padding: '8px' }}>
                                      {obj.locationName}
                                    </div>
                                  ))
                                }
                              </div>
                            )
                          }
                          </div>
                        );
                      }
                    })()
                  }
                </Paper>
              </div>
            );
          }, { nodes: [], grouped: [] })
        }
        <Dialog
          open={this.state.openSideBySide}
          onRequestClose={this.closeDialog}
          contentStyle={{ width: '880px', maxWidth: '880px' }}
          title="Side by Side Comparison"
          autoScrollBodyContent
          actions={[
            <FlatButton
              key="dismiss"
              label="Dismiss"
              secondary
              onClick={this.closeDialog}
            />,
          ]}
        >
          {
            Boolean(logs[this.state.logIndexToOpen]) && (
              <SideBySideComparison
                {...logs[this.state.logIndexToOpen]}
              />
            )
          }
        </Dialog>
      </div>
    );
  }
}

export default connect(null, { push: routerPush })(injectSheet(styles)(c));



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/change-log/all-logs.js